import React from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import Notes from "../../../assets/images/notes.svg";
import User from "../../../assets/images/user.svg";
import Logout from "../../../assets/images/Logout.svg";
import CorpUser from "../../../assets/images/corp-user.png";
import Logo from "../../../assets/images/dark-logo.svg";
import "./sidebar.scss";
import { sidebarToggleItems } from "../../../utility/constants";
import Dot from "../../../assets/images/dot.svg";
import VehicleTypesDD from "../../form-controls/DropDowns/VehicleTypesDD";
import BranchListDD from "../../form-controls/DropDowns/BranchListDD";
import authorization from "../../../utility/authorization";
class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.authUser = this.props.auth.getAuthUser();
    this.state = { branchId: authorization.getBranchAccessSelected() };
  }

  toggleMenuItem = type => e => {
    e.stopPropagation(); // stop propagation to avoid parrent toggle
    this.props.dispatch({
      type: "TOGGLE_SIDEBAR_MENU",
      payload: {
        ...sidebarToggleItems,
        users:
          type === "drivers" || type === "taxidaUsers" || type === "operators",
        [type]: !this.props.toggleItems[type]
      }
    });
  };

  mobToggleSidebar = () => {
    const mobile = window.matchMedia("(max-width: 768px)");
    if (mobile.matches) {
      this.props.dispatch({
        type: "TOGGLE_SIDEBAR",
        payload: { visible: true }
      });
    }
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  handleClickOutside = e => {
    const mobile = window.matchMedia("(max-width: 768px)");
    if (
      mobile.matches &&
      this.wrapperRef &&
      !this.wrapperRef.contains(e.target)
    ) {
      this.props.dispatch({
        type: "TOGGLE_SIDEBAR",
        payload: { visible: true }
      });
    }
  };
  onchangeDropDown = (name, value) => {
    authorization.setBranchAccessSelected(value);
    this.setState({ branchId: value }, () => {
      window.location.reload();
    });
  };

  render() {
    const {
      corporateEmail,
      roleId,
      firstName,
      accessMatrix,
      bookingApproval,
      newbookingReqForAdmins,
      showReports,
      showTripList,
      showTripsheet,
      isApiEnabled,
      fareApprovalEnabled,
      isGeneralTripsEnabled,
      isShuttleTripsEnabled
    } = this.props.configCheck.response || "";

    let { additionalUserRole } = this.props.configCheck.response || [];
    additionalUserRole = additionalUserRole && additionalUserRole.split(",");
    const {
      sidebar: { visible: isOpen },
      toggleItems
    } = this.props;
    const { branchId } = this.state;
    return (
      <div
        ref={this.setWrapperRef}
        className={isOpen ? "sidebar" : "sidebar open"}
      >
        <div className="sidebar-head">
          <img src={CorpUser} alt="profile" width="50" height="50" />
          <div>
            <h1>{firstName}</h1>
            <p>{corporateEmail}</p>
            {(() => {
              if (roleId === 15) {
                return <span>Manager</span>;
              } else if (roleId === 6) {
                return <span>Corporate user</span>;
              } else if (roleId === 12) {
                return <span>Branch manager</span>;
              } else if (roleId === 13) {
                return <span>Admin</span>;
              }
            })()}
          </div>
        </div>
        {roleId === 15 || roleId === 6 ? (
          <div className="label-input">
            <div>
              <span className="custom-dropdown big yl-btn">
                <BranchListDD
                  name="branchId"
                  id="branchId"
                  data-validation-name="Vehicle Type"
                  onChange={this.onchangeDropDown}
                  value={branchId}
                />
              </span>
              {/*{displayError(inputErrors.vehicleTypeId)}*/}
            </div>
          </div>
        ) : (
          ""
        )}
        <nav className="side-nav">
          <ul className="nav-list">
            {newbookingReqForAdmins && roleId === 12 ? (
              <li className="list-items">
                <NavLink
                  onClick={this.mobToggleSidebar}
                  tabIndex="1"
                  to="/booking/add"
                >
                  <img src={Notes} alt="booking" />
                  <span>New booking</span>
                </NavLink>
              </li>
            ) : (
              ""
            )}
            {isGeneralTripsEnabled || roleId === 15 || roleId === 6 ? (
              <div>
                <li className="list-items">
                  <button
                    type="button"
                    tabIndex="1"
                    onClick={this.toggleMenuItem("bookings")}
                  >
                    <img src={Notes} alt="newBook" />
                    <span>General trips</span>
                    <i
                      className={
                        toggleItems.bookings ? "chevron down" : "chevron right"
                      }
                    />
                  </button>
                  <ul
                    className={
                      toggleItems.bookings
                        ? "list-item-nav responsive"
                        : "list-item-nav"
                    }
                    onClick={e => e.stopPropagation()}
                  >
                    {bookingApproval ||
                    fareApprovalEnabled ||
                    roleId === 15 ||
                    roleId === 12 ||
                    roleId === 6 ? (
                      <li className="list-items list-bl">
                        <NavLink
                          onClick={this.mobToggleSidebar}
                          className="bl-pad"
                          to="/triplist/pending"
                        >
                          <img className="sidebar-dot" src={Dot} alt="list" />
                          <span>Pending</span>
                        </NavLink>
                      </li>
                    ) : (
                      ""
                    )}
                    <li className="list-items list-bl">
                      <NavLink
                        onClick={this.mobToggleSidebar}
                        className="bl-pad"
                        to="/triplist/inprogress"
                      >
                        <img className="sidebar-dot" src={Dot} alt="list" />
                        <span>Inprogress</span>
                      </NavLink>
                    </li>
                    <li className="list-items list-bl">
                      <NavLink
                        onClick={this.mobToggleSidebar}
                        className="bl-pad"
                        to="/triplist/completed"
                      >
                        <img className="sidebar-dot" src={Dot} alt="list" />
                        <span>Closed</span>
                      </NavLink>
                    </li>
                  </ul>
                </li>
              </div>
            ) : (
              ""
            )}
            {(showTripList && isShuttleTripsEnabled && roleId !== 13) ||
            roleId === 15 ||
            roleId === 6 ? (
              <div>
                <li className="list-items">
                  <button
                    type="button"
                    tabIndex="1"
                    onClick={this.toggleMenuItem("ets")}
                  >
                    <img src={Notes} alt="newBook" />
                    <span>Shuttle trips</span>
                    <i
                      className={
                        toggleItems.ets ? "chevron down" : "chevron right"
                      }
                    />
                  </button>
                  <ul
                    className={
                      toggleItems.ets
                        ? "list-item-nav responsive"
                        : "list-item-nav"
                    }
                    onClick={e => e.stopPropagation()}
                  >
                    {bookingApproval ||
                    fareApprovalEnabled ||
                    roleId === 15 ||
                    roleId === 6 ? (
                      <li className="list-items list-bl">
                        <NavLink
                          onClick={this.mobToggleSidebar}
                          className="bl-pad"
                          to="/ets-triplist/inprogress"
                        >
                          <img className="sidebar-dot" src={Dot} alt="list" />
                          <span>Inprogress</span>
                        </NavLink>
                      </li>
                    ) : (
                      ""
                    )}
                    <li className="list-items list-bl">
                      <NavLink
                        onClick={this.mobToggleSidebar}
                        className="bl-pad"
                        to="/ets-triplist/closed"
                      >
                        <img className="sidebar-dot" src={Dot} alt="list" />
                        <span>Closed</span>
                      </NavLink>
                    </li>
                  </ul>
                </li>
              </div>
            ) : (
              ""
            )}
            {(additionalUserRole &&
              roleId !== 13 &&
              additionalUserRole.length > 0) ||
            roleId === 15 ||
            roleId === 6 ? (
              <li className="list-items" onClick={this.toggleMenuItem("users")}>
                <button type="button" tabIndex="1">
                  <img src={User} alt="newBook" />
                  <span>Users</span>
                  <i
                    className={
                      toggleItems.users ? "chevron down" : "chevron right"
                    }
                  />
                </button>
                <ul
                  className={
                    toggleItems.users
                      ? "list-item-nav responsive"
                      : "list-item-nav"
                  }
                  onClick={e => e.stopPropagation()}
                >
                  {/*{(additionalUserRole &&
                    additionalUserRole.includes("admin")) ||
                  roleId === 15 ||
                  roleId === 6 ? (
                    <li className="list-items list-bl">
                      <NavLink
                        onClick={this.mobToggleSidebar}
                        className="bl-pad"
                        to="/users/admin"
                      >
                        <img className="sidebar-dot" src={Dot} alt="list" />
                        <span>Admin</span>
                      </NavLink>
                    </li>
                  ) : (
                    ""
                  )}*/}
                  {(additionalUserRole &&
                    additionalUserRole.includes("employee")) ||
                  roleId === 15 ||
                  roleId === 6 ? (
                    <li className="list-items list-bl">
                      <NavLink
                        onClick={this.mobToggleSidebar}
                        className="bl-pad"
                        to="/users/employee"
                      >
                        <img className="sidebar-dot" src={Dot} alt="list" />
                        <span>Employee</span>
                      </NavLink>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </li>
            ) : (
              ""
            )}
          </ul>
          <ul className="nav-list">
            {showTripsheet || roleId === 15 || roleId === 6 ? (
              <li className="list-items">
                <button
                  type="button"
                  tabIndex="1"
                  onClick={this.toggleMenuItem("tripsheet")}
                >
                  <img src={Notes} alt="newBook" />
                  <span>Tripsheet</span>
                  <i
                    className={
                      toggleItems.tripsheet ? "chevron down" : "chevron right"
                    }
                  />
                </button>
                <ul
                  className={
                    toggleItems.tripsheet
                      ? "list-item-nav responsive"
                      : "list-item-nav"
                  }
                  onClick={e => e.stopPropagation()}
                >
                  <li className="list-items list-bl">
                    <NavLink
                      onClick={this.mobToggleSidebar}
                      className="bl-pad"
                      to="/tripsheet/general"
                    >
                      <img className="sidebar-dot" src={Dot} alt="list" />
                      <span>General</span>
                    </NavLink>
                  </li>
                  {roleId !== 13 && isShuttleTripsEnabled ? (
                    <li className="list-items list-bl">
                      <NavLink
                        onClick={this.mobToggleSidebar}
                        className="bl-pad"
                        to="/tripsheet/shuttle"
                      >
                        <img className="sidebar-dot" src={Dot} alt="list" />
                        <span>Shuttle</span>
                      </NavLink>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </li>
            ) : (
              ""
            )}
          </ul>
          <ul className="nav-list">
            {showReports || roleId === 15 || roleId === 6 ? (
              <li className="list-items">
                <button
                  type="button"
                  tabIndex="1"
                  onClick={this.toggleMenuItem("reports")}
                >
                  <img src={Notes} alt="newBook" />
                  <span>Reports</span>
                  <i
                    className={
                      toggleItems.reports ? "chevron down" : "chevron right"
                    }
                  />
                </button>
                <ul
                  className={
                    toggleItems.reports
                      ? "list-item-nav responsive"
                      : "list-item-nav"
                  }
                  onClick={e => e.stopPropagation()}
                >
                  <li className="list-items list-bl">
                    <NavLink
                      onClick={this.mobToggleSidebar}
                      className="bl-pad"
                      to="/reports/general"
                    >
                      <img className="sidebar-dot" src={Dot} alt="list" />
                      <span>General</span>
                    </NavLink>
                  </li>
                  {roleId !== 13 && isShuttleTripsEnabled ? (
                    <li className="list-items list-bl">
                      <NavLink
                        onClick={this.mobToggleSidebar}
                        className="bl-pad"
                        to="/reports/shuttle"
                      >
                        <img className="sidebar-dot" src={Dot} alt="list" />
                        <span>Shuttle</span>
                      </NavLink>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </li>
            ) : (
              ""
            )}
          </ul>
          {isApiEnabled ? (
            <ul className="nav-list">
              <li className="list-items">
                <NavLink
                  onClick={this.mobToggleSidebar}
                  tabIndex="1"
                  to="/api-document"
                >
                  <img src={Notes} alt="reports" />
                  <span>API Document</span>
                </NavLink>
              </li>
            </ul>
          ) : (
            ""
          )}
          <ul className="nav-list">
            <li className="list-items">
              <NavLink
                onClick={this.props.auth.logout}
                tabIndex="1"
                to="/signout"
              >
                <img src={Logout} alt="sign-out" />
                <span>Signout</span>
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}
export default connect(state => {
  return {
    sidebar: state.sidebar,
    toggleItems: state.sidebarMenuToggle,
    configCheck: state.configCheck
  };
})(Sidebar);
